import React from 'react'
import { useGetCustomerSourceByCustomerSourceId } from '../../../../api/dealership/customers/sources/useGetCustomerSourceByCustomerSourceId'
import { VENDOR } from '../../../../lib/utils/vendors'
import loadable from '@loadable/component'
import { LoadingComponent } from '@demandlocal/components'
import EditTekionSource from './ThirdParty/EditTekionSource'

const components = {
  [VENDOR.Elead]: loadable(() => import('./ThirdParty/EditEleadSource')),
  [VENDOR.GoogleSpreadSheets]: loadable(
    () => import('./ThirdParty/EditGoogleSpreadsheetsSource'),
  ),
  [VENDOR.FacebookLeads]: loadable(() => import('./ThirdParty/EditFacebookLeadsSource')),
  [VENDOR.GoogleLeads]: loadable(() => import('./ThirdParty/EditGoogleLeadsSource')),
  [VENDOR.DealerVault]: loadable(() => import('./ThirdParty/EditDealerVaultSource')),
  [VENDOR.VinSolutions]: loadable(() => import('./ThirdParty/EditVinSolutionsSource')),
  [VENDOR.CDK]: loadable(() => import('./ThirdParty/EditCDKSource')),
  [VENDOR.DealerSocket]: loadable(() => import('./ThirdParty/EditDealerSocketSource')),
  [VENDOR.Procede]: loadable(() => import('./ThirdParty/EditProcedeSource')),
  [VENDOR.Tekion]: loadable(() => import('./ThirdParty/EditTekionSource')),
}
type Props = {
  customer_source_id: number
}
const EditThirdPartySource = (props: Props): JSX.Element => {
  const { customer_source_id } = props
  const { data: source, isLoading } =
    useGetCustomerSourceByCustomerSourceId(customer_source_id)
  const vendor_id: keyof typeof components = source?.mongoData?.config?.vendor_id

  if (isLoading) return <LoadingComponent title={'Loading...'} />
  const Component = components[Number(vendor_id)]
  return <Component customer_source_id={customer_source_id} />
}

export default EditThirdPartySource
